const eventVoucherService = (couponCategory, couponName, carModel, serviceType, promoCode) => {
  if (typeof window !== 'undefined') {
    (window as any)?.dataLayer?.push({
      event: 'generalEvent',
      eventName: `${serviceType === 'SERVICE_COUPON' ? 'kupon' : 'paket'}_servis_pilih_voucher_promo`,
      eventCategory: `${serviceType === 'SERVICE_COUPON' ? 'kupon' : 'paket'} servis page`,
      eventAction: `click on pilih voucher on voucher promo pop up`,
      eventLabel: `${couponCategory?.toLowerCase() || 'semua'} - ${couponName?.toLowerCase() || 'not available'} - pdp`,
      promoCode: promoCode?.toLowerCase() || 'not available',
      carModel: carModel?.toLowerCase() || 'not available',
    });
  }
};
export default eventVoucherService;
